<template>
  <button type="button" class="btn btn-primary">
    <slot></slot>
  </button>
</template>
